<template>
    <div class="xmlrepositorie-search">
        <b-row>
            <b-col md="10" sm="12">
                <PageTitle
                    icon="fa fa-search"
                    main="Controle"
                    sub="Repositório de XML"
                />
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col xs="12">
                <b-button
                    size="sm"
                    v-b-modal.modalXml
                    variant="dark"
                    class="mr-2"
                    >Adicionar XML (NFe)
                </b-button>
                <b-button
                    size="sm"
                    v-b-modal.modalXmlNfse
                    variant="dark"
                    class="mr-2"
                    >Adicionar XML (NFSe)
                </b-button>
                <b-button
                    size="sm"
                    class="fa"
                    :class="icon"
                    @click="loadXmlRepositories()"
                    variant="dark"
                >
                </b-button>
            </b-col>
        </b-row>
        <hr />
        <b-row>
            <b-col md="3" sm="12">
                <b-form-group
                    label="Empresa:"
                    label-for="changetracking-search-company_id"
                >
                    <b-form-select
                        id="changetracking-search-company_id"
                        @input="loadXmlRepositories"
                        size="sm"
                        :options="companys"
                        v-model="company_id"
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
                <b-form-group
                    label="Utilizado:"
                    label-for="xmlrepositorie-search-receipt"
                >
                    <b-form-select
                        id="xmlrepositorie-search-receipt"
                        @input="loadXmlRepositories"
                        size="sm"
                        :options="questionboxyesnoalls"
                        v-model="receipt"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="1" sm="2">
                <b-form-group label="ID" label-for="entity-id">
                    <b-form-input
                        id="entity-id"
                        type="text"
                        v-model="entity_id"
                        @input=";[setEntity(), loadReleases()]"
                        size="sm"
                        placeholder="Código..."
                    />
                </b-form-group>
            </b-col>
            <b-link v-b-modal.modalEntity class="fa fa-search mt-4"></b-link>
            <b-col md="4" sm="8">
                <b-form-group label="Nome:" label-for="entity-name_entity">
                    <b-form-input
                        id="entity-name_entity"
                        type="text"
                        v-model="entity.name_entity"
                        size="sm"
                        :readonly="true"
                        placeholder="Nome..."
                    />
                </b-form-group>
            </b-col>
            <b-col md="2" sm="2">
                <b-form-group label="CNPJ:" label-for="entity-cnpj_cpf">
                    <b-form-input
                        id="entity-cnpj_cpf"
                        type="text"
                        v-model="entity.cnpj_cpf"
                        size="sm"
                        :readonly="true"
                        placeholder=""
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12" sm="12">
                <template>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="my-table"
                    ></b-pagination>
                    <transition name="slide" type="animation" appear>
                        <b-table
                            id="my-table"
                            class="table-responsive"
                            :per-page="perPage"
                            :current-page="currentPage"
                            hover
                            key="slide"
                            head-variant="light"
                            :items="xmlrepositories"
                            :fields="fieldsXmlRepositorie"
                        >
                            <template v-slot:cell(actions)="data">
                                <b-button
                                    title="Cancelar registro"
                                    size="sm"
                                    variant="light"
                                    @click="
                                        ;[
                                            setXmlRepositorie(data.item),
                                            showMsgBoxCancel()
                                        ]
                                    "
                                    class="mr-2 mt-2 mb-2"
                                >
                                    <i class="fa fa-ban"></i>
                                </b-button>
                            </template>
                        </b-table>
                    </transition>
                </template>
            </b-col>
        </b-row>
        <b-modal
            id="modalEntity"
            ref="modal"
            hide-footer
            title-tag="h6"
            size="lg"
            title="Consulta de Fornecedor"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
        >
            <b-form>
                <b-row>
                    <b-col md="6" sm="8">
                        <b-form-group
                            label="Nome:"
                            label-for="entity-name_entity"
                        >
                            <b-form-input
                                id="entity-name_entity"
                                type="text"
                                v-model="entity.name_entity"
                                size="sm"
                                :readonly="true"
                                placeholder="Nome..."
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="2">
                        <b-form-group
                            label="CPF/CNPJ:"
                            label-for="entity-cnpj_cpf"
                        >
                            <b-form-input
                                id="entity-cnpj_cpf"
                                type="text"
                                v-model="entity.cnpj_cpf"
                                size="sm"
                                :readonly="true"
                                placeholder=""
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="control-label">
                                <i class="fa fa-search"></i> Pesquisar
                            </label>
                            <b-button
                                size="sm"
                                class=" ml-2 mb-2 fa fa-search"
                                @click="
                                    ;[loadEntitys(), (showEntity = !showEntity)]
                                "
                                variant="light"
                            ></b-button>
                            <input
                                type="text"
                                icon="search"
                                v-model="searchEntity"
                                placeholder="Informe o nome"
                                class="form-control"
                            />
                            <b-form-select
                                id="xmlrepositorie-search-type_entity_id"
                                @input="loadEntitys"
                                size="sm"
                                class="mt-2"
                                :options="typeentitys"
                                v-model="type_entity_id"
                            />
                        </div>
                    </div>
                </b-row>

                <b-table
                    class="table-responsive"
                    hover
                    head-variant="light"
                    :per-page="perPage"
                    :current-page="currentPage"
                    v-show="showEntity"
                    :items="filteredListEntity"
                    :fields="fieldsEntity"
                >
                    <template v-slot:cell(actions)="data">
                        <b-button
                            title="Selecionar o registro"
                            size="sm"
                            variant="outline-secondary"
                            @click="
                                ;[
                                    setSearchEntity(data.item),
                                    (showEntity = !showEntity)
                                ]
                            "
                            class="mr-2 mt-2"
                        >
                            <i class="fa fa-check-square-o"></i>
                        </b-button>
                    </template>
                </b-table>
                <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    aria-controls="my-table"
                ></b-pagination>
            </b-form>
        </b-modal>
        <b-modal
            id="modalXml"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="Importação de Xml de Produto"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveXmlNfe"
        >
            <b-form>
                <b-row>
                    <b-col md="10" sm="12">
                        <b-form-group
                            label="Arquivo XML NFe:"
                            label-for="xmlrepositorie-file"
                        >
                            <b-form-file
                                v-model="file"
                                id="xmlrepositorie-file"
                                ref="file"
                                @input="saveImagem"
                                class="mt-3"
                                placeholder="Escolha um arquivo..."
                                accept=".xml"
                            ></b-form-file>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal
            id="modalXmlNfse"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="Importação de Xml de Serviço"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveXmlNfse"
        >
            <b-form>
                <b-row>
                    <b-col md="10" sm="12">
                        <b-form-group
                            label="Arquivo XML NFSe:"
                            label-for="xmlrepositorie-file"
                        >
                            <b-form-file
                                v-model="file"
                                id="xmlrepositorie-file"
                                ref="file"
                                @input="saveImagem"
                                class="mt-3"
                                placeholder="Escolha um arquivo..."
                                accept=".xml"
                            ></b-form-file>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
var moment = require('moment-timezone')

export default {
    name: 'XmlRepositorie',
    components: { PageTitle },
    data: function() {
        return {
            mode: 'insert',
            receipt: null,
            company_id: null,
            entity_id: null,
            type_entity_id: null,
            search: '',
            searchEntity: '',
            file: '',
            xmlrepositorie: {},
            xmlrepositories: [],
            release: {},
            documententry: {},
            entity: {},
            entitys: [],
            entitysshearch: [],
            companys: [],
            questionboxyesnoalls: [],
            typeentitys: [],
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            showTable: false,
            showXmlRepositorie: false,
            showEntity: false,
            perPage: 5,
            currentPage: 1,
            fieldsXmlRepositorie: [
                {
                    key: 'register',
                    label: 'Registrado em',
                    sortable: true,
                    formatter: value =>
                        value ? moment(value).format('DD-MM-YYYY LT') : ''
                },
                { key: 'name_file_xml', label: 'Arquivo', sortable: false },
                {
                    key: 'issue_date_xml',
                    label: 'Emissão',
                    sortable: true,
                    formatter: value =>
                        value ? moment(value).format('DD-MM-YYYY LT') : ''
                },
                { key: 'cnpj_file_xml', label: 'CNPJ', sortable: true },
                {
                    key: 'name_entity_file_xml',
                    label: 'Razão Social',
                    sortable: false
                },
                { key: 'type_doc_file_xml', label: 'Modelo.', sortable: false },
                {
                    key: 'number_doc_file_xml',
                    label: 'Nº Doc.',
                    sortable: false
                },
                {
                    key: 'value_doc_file_xml',
                    label: 'Valor Doc.',
                    sortable: false
                },
                { key: 'actions', label: 'Ações', variant: 'light' }
            ],
            fieldsEntity: [
                { key: 'id', label: 'Código', sortable: true },
                { key: 'name_entity', label: 'Nome', sortable: true },
                { key: 'cnpj_cpf', label: 'CPF/CNPJ/Código', sortable: false },
                { key: 'name_type_entity', label: 'Tipo', sortable: false },
                {
                    key: 'blocked',
                    label: 'Bloqueado',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não')
                },
                { key: 'actions', label: 'Ações', variant: 'light' }
            ]
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        compan() {
            return this.$store.state.compan
        },
        filteredListEntity() {
            return this.entitysshearch.filter(entity => {
                return entity.name_entity
                    .toLowerCase()
                    .includes(this.searchEntity.toLowerCase())
            })
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        },
        rows() {
            return this.xmlrepositories.length
        }
    },
    methods: {
        showMsgBoxCancel() {
            this.boxCancel = ''
            this.$bvModal
                .msgBoxConfirm('Deseja Excluir o Registro ?', {
                    title: 'Por Favor Confirme',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'SIM',
                    cancelTitle: 'NÃO',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        this.removeXmlRepositorie()
                    }
                })
        },
        formatDate(date) {
            return moment.utc(date).format('YYYY-MM-DD')
        },
        loadEntitys() {
            if (this.compan.id) {
                const url = `${baseApiUrl}/entitysallcompany/${this.compan.id}/?type_entity_id=${this.type_entity_id}`
                axios.get(url).then(res => {
                    this.entitysshearch = res.data
                })
            } else {
                this.$toasted.global.defaultError({ msg: 'Logar na Empresa' })
            }
        },
        loadXmlRepositories() {
            const url = `${baseApiUrl}/xmlrepositoriescompany/${this.company_id}`
            // /?receipt=${this.receipt}&entity_id=${this.entity_id}
            axios.get(url).then(res => {
                this.xmlrepositories = res.data
            })
        },
        setXmlRepositorie(xmlrepositorie) {
            this.xmlrepositorie.id = xmlrepositorie.id
        },
        async removeXmlRepositorie() {
            await axios
                .delete(
                    `${baseApiUrl}/xmlrepositories/${this.xmlrepositorie.id}`
                )
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.loadXmlRepositories()
                })
                .catch(showError)
        },

        setEntity(entity) {
            if (!this.xmlrepositorie.entity_id) {
                this.xmlrepositorie.entity_id = entity.id
            }

            const url = `${baseApiUrl}/entitys/${this.xmlrepositorie.entity_id}`
            axios(url).then(res => (this.entity = res.data))
        },
        actionEditXmlRepositorie(xmlrepositorie) {
            if (xmlrepositorie.issue_date)
                xmlrepositorie.issue_date = this.formatDate(
                    xmlrepositorie.issue_date
                )
            if (xmlrepositorie.xmlrepositorie_date)
                xmlrepositorie.xmlrepositorie_date = this.formatDate(
                    xmlrepositorie.xmlrepositorie_date
                )

            this.$router.push({
                name: 'RecordXmlRepositorie',
                params: { id: xmlrepositorie.id },
                query: { xmlrepositoriebase: xmlrepositorie }
            })
        },
        loadCompanys() {
            this.company_id = this.compan.id
            this.loadXmlRepositories()
            this.showTable = true

            const url = `${baseApiUrl}/companys`
            axios.get(url).then(res => {
                this.companys = res.data.map(company => {
                    return { value: company.id, text: company.name_company }
                })
            })
        },
        loadQuestionBoxYesNoAlls() {
            const url = `${baseApiUrl}/questionboxyesnoalls`
            axios.get(url).then(res => {
                this.questionboxyesnoalls = res.data.map(
                    questionboxyesnoall => {
                        return {
                            value: questionboxyesnoall.id,
                            text: questionboxyesnoall.name_question_box
                        }
                    }
                )
            })
            this.receipt = 0
        },
        loadTypeEntitys() {
            const url = `${baseApiUrl}/typeentitysall`
            axios.get(url).then(res => {
                this.typeentitys = res.data.map(typeentity => {
                    return { value: typeentity.id, text: typeentity.name }
                })
            })
        },
        actionNewRelease(xmlrepositorie) {
            if (!this.compan) {
                this.$toasted.global.defaultError({ msg: 'Logar na Empresa' })
            } else {
                this.release = {
                    company_id: xmlrepositorie.company_id
                }
                this.$router.push({
                    name: 'Recordrelease',
                    query: { releasebase: this.release }
                })
            }
        },
        setSearchEntity(entity) {
            this.entity_id = entity.id
            this.entity = { ...entity }
        },
        async saveImagem() {
            let formData = new FormData()
            formData.append('file', this.file)

            await axios
                .post(`${baseApiUrl}/storagefiles`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.getLastStorageFile()
                })
                .catch(showError)
        },
        async getLastStorageFile() {
            const url = `${baseApiUrl}/storagefilesbylast/?name_file=${this.file.name}`
            await axios(url).then(
                res =>
                    (this.xmlrepositorie = {
                        storage_file_id: res.data.id,
                        name_file_xml: res.data.name_file,
                        path_file_xml: res.data.path_file
                    })
            )
        },
        async saveXmlNfe() {
            if (!this.compan) {
                this.$toasted.global.defaultError({ msg: 'Logar na Empresa' })
            } else {
                this.xmlrepositorie.company_id_xml = this.compan.id
                const method = 'post'
                await axios[method](
                    `${baseApiUrl}/xmlrepositories`,
                    this.xmlrepositorie
                )
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.loadXmlRepositories()
                    })
                    .catch(showError)
            }
        },
        async saveXmlNfse() {
            if (!this.compan) {
                this.$toasted.global.defaultError({ msg: 'Logar na Empresa' })
            } else {
                const method = 'post'
                await axios[method](
                    `${baseApiUrl}/xmlrepositoriesservice`,
                    this.xmlrepositorie
                )
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                    })
                    .catch(showError)
            }
        }
    },
    mounted() {
        this.loadCompanys()
        this.loadQuestionBoxYesNoAlls()
        this.loadTypeEntitys()
    }
}
</script>

<style>
.xmlrepositorie-search {
    font-size: 0.7rem;
}

.xmlrepositorie-search input,
label,
form {
    font-size: 0.7rem;
}
.xmlrepositorie-search button {
    font-size: 0.7rem;
}

.xmlrepositorie-search select {
    font-size: 0.7rem;
}

.xmlrepositorie-search table {
    font-size: 0.7rem;
}

#modalEntity {
    font-size: 0.7rem;
}

#modalXml {
    font-size: 0.7rem;
}
#modalXml input {
    font-size: 0.7rem;
}

#modalXml button {
    font-size: 0.7rem;
}

#modalXmlNfse {
    font-size: 0.7rem;
}
#modalXmlNfse input {
    font-size: 0.7rem;
}
#modalXmlNfse button {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
